export default "__VITE_ASSET__13eddeae__"